<template>
  <div>
    <iframe id="IframeTicket" frameborder="0"></iframe>
    <v-btn :disabled="faltaDinero" class="ma-1" color="info" dark block @click="printActualTicket()"
      >Imprimir Ticket</v-btn
    >
  </div>
</template>

<script>
export default {
  name: "IframeTicket",
  props: ["lmth", 'faltaDinero'],
  data() {
    return {};
  },
  methods: {
    printActualTicket() {
      setTimeout(async () => {
        this.$pgsHelper.printTicket(this, this.lmth);
      }, 2000);
    },
  },

  mounted() {
    document.querySelectorAll("iframe")[0].style =
      "height: 50vh !important;  width:100%;";
    document
      .getElementById("IframeTicket")
      .contentWindow.document.write(this.lmth);
  },
};
</script>
